import { useMemo } from 'react';
import { stringUtil } from '@goodfynd/utils';

import endpoints from '../../services/api/endpoints';
import useFetch from '../../services/api/useFetch';
import type { UserAlertsResponse } from '../../types/alerts';

export const useAlertsApi = () => {
  const api = useFetch();
  return useMemo(() => {
    return {
      async getAlerts(userId: string): Promise<UserAlertsResponse | undefined> {
        try {
          const data: UserAlertsResponse = await api.post(
            stringUtil.replace(endpoints.alerts.user, {
              ':id': userId,
            })
          );
          return { ...data };
        } catch (error: any) {
          return Promise.reject({ success: false, ...error });
        }
      },

      async dismissAlert(alertId: string): Promise<void> {
        try {
          await api.post(
            stringUtil.replace(endpoints.alerts.dismiss, {
              ':id': alertId,
            })
          );
        } catch (error: any) {
          return Promise.reject(error);
        }
      },

      async clickedAlert(userId: string): Promise<void> {
        try {
          await api.post(
            stringUtil.replace(endpoints.alerts.clicked, {
              ':id': userId,
            })
          );
        } catch (error: any) {
          return Promise.reject(error);
        }
      },
    };
  }, [api]);
};
